export const adicionaZero = (numero: any) => {
  if (numero <= 9) return "0" + numero;
  else return numero;
};

export const formatData = (data: string) => {
  const tiraTraco = data.replace(/-/g, "/");

  let dataAtual2 = new Date(tiraTraco); //02/10/2022

  let dataAtualFormatada2 =
    adicionaZero(dataAtual2.getDate().toString()) +
    "/" +
    adicionaZero(dataAtual2.getMonth() + 1).toString() +
    "/" +
    dataAtual2.getFullYear();
  return dataAtualFormatada2;
};

export const FormataStringData = (data: any) => {
  //tranforma 00/00/0000 em 0000-00-00
  var dia = data.split("/")[0];
  var mes = data.split("/")[1];
  var ano = data.split("/")[2];

  return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia).slice(-2);
};

export const formataStringDataAPI = (data: any) => {
  //tranforma 0000-00-00 em 00/00/0000
  var ano = data.split("-")[0];
  var mes = data.split("-")[1];
  var dia = data.split("-")[2];

  return dia.substring(0,2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
};
